import { render, staticRenderFns } from "./AscReleaseNotesContainer.vue?vue&type=template&id=3e2e12f4&"
import script from "./AscReleaseNotesContainer.vue?vue&type=script&lang=js&"
export * from "./AscReleaseNotesContainer.vue?vue&type=script&lang=js&"
import style0 from "./AscReleaseNotesContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
